package br.com.vvrefeicoes.portal.domain.model

data class PeopleKpis(
    val fopagCents: Long,
    val variableCostsCents: Long,
    val turnoverPercent: Double,
    val overtimeCents: Long,
    val bonusCents: Long,
    val absenteeismPercent: Double,
)

data class PeopleMonth(
    val period: MonthPeriod,
    val fopagCents: Long,
    val overtimeCents: Long,
    val bonusCents: Long,
    val absenteeismPercent: Double,
    val hires: Int,
    val terminations: Int,
    val turnoverPercent: Double,
)

data class PeopleUnit(
    val unitId: String,
    val unitName: String,
    val employees: Int,
    val vacancies: Int,
    val fopagCents: Long,
    val programmedHours: Int,
    val absentHours: Int,
    val absenteeismPercent: Double,
    val hires: Int,
    val terminations: Int,
    val effective: Int,
    val turnoverPercent: Double,
    val overtimeCents: Long,
    val nightShiftCents: Long,
    val bonusCents: Long,
)

data class PeopleSnapshot(
    val period: MonthPeriod,
    val kpis: PeopleKpis,
    val months: List<MonthPeriod>,
    val monthly: List<PeopleMonth>,
    val units: List<PeopleUnit>,
) {
    companion object {
        fun empty(period: MonthPeriod): PeopleSnapshot =
            PeopleSnapshot(
                period = period,
                kpis =
                    PeopleKpis(
                        fopagCents = 0L,
                        variableCostsCents = 0L,
                        turnoverPercent = 0.0,
                        overtimeCents = 0L,
                        bonusCents = 0L,
                        absenteeismPercent = 0.0,
                    ),
                months = emptyList(),
                monthly = emptyList(),
                units = emptyList(),
            )
    }
}
